<template>
<div class="cart-products">
  <section id="servicios" class="seccion-gris"> 
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="card shadow-sm carrito">
          <div class="card-body">
            <h4 class="h4-carrito">Su Carrito de pedidos</h4>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-sm-12">
        <div class="row">
          <template v-if="cartProducts.length > 0">
            <div class="col-sm-6 col-md-4 col-lg-4" v-for="(item, index) in cartProducts" :key="index">

              <div class="card mb-4 shadow-sm" id="card-product">
                <div class="card-image-product"  @click="navigateProductDetail(item)">
                  <img
                  class="card-img-top mt-2 imagen-cover"
                  v-bind:src='imgPreUrl+ item.photo_product +"x320.jpg"'
                  alt="Card image cap"
                  >
                </div>
                <div class="card-body">
                   <template v-if="item.new_product===true">
                        <div class="product-label">
													<span class="new"> Nuevo </span>
												</div> 
                   </template>                    
                    <div class="card-body">
                      <h6 class="card-text-name" @click="navigateProductDetail(item)">{{item.name_product_es}}</h6>
      
                        <template v-if="item.old_price_product>item.price_product">
                            <p class="card-text-old-price" @click="navigateProductDetail(item)">Antes: <strike>S/. {{item.old_price_product | currency}}</strike></p>   
                        </template>  
                        <template v-else>
                            <p class="card-text-old-price" @click="navigateProductDetail(item)"></p>   
                        </template>           
                        <p class="card-text-price" @click="navigateProductDetail(item)">{{item.price_product | currency }}</p>
                        <div class="align-items-center">
                          <div class="btn-group">
                              <button
                                type="button"
                                class="btn btn-al-celeste-solid btn-sm" 
                                v-on:click="removeProductCart(item)"
                              > Remover <i class="fa fa-trash"></i></button>
                          </div>
                        </div>
                    </div>
                </div>
              </div>

            </div>
          </template>
          <template v-else>
            <div class="error-template container">
              <h2>Su carrito está vacío</h2>
              <div class="error-details">Agrega productos ahora >></div>
              <div class="error-actions">
                <router-link to="/productos">Seguir comprando</router-link>
              </div>
            </div>
          </template>
        </div>
      </div>
      
      <div class="col-lg-4 col-sm-12">
        <cart-calculator ref="cartCalculator"></cart-calculator>
      </div>
      
    </div>
  </div>
  </section>
   <TwoModules></TwoModules>
   <NewModules></NewModules>
  </div>
</template>

<script>
import TwoModules from "@/components/products/TwoModules.vue";
import NewModules from "@/components/products/NewModule.vue";
import {config_settings} from '../../../config.js'
import { mapState, mapActions, mapMutations } from "vuex";
import CartCalculator from "./CartCalculator";

//HTTP ERROR STATUS
const NOT_FOUND = 404;
const BAD_REQUEST = 400;
const UNAUTHORIZED = 401;
const INTERNAL_SERVER_ERROR = 500;

export default {
  name: "CartProducts",
  components: { CartCalculator, TwoModules,
    NewModules },
  data() {
    return {
      imgPreUrl : config_settings.PHOTO_SERVER_URL+'/'
    };
  },
  computed: mapState(["cartProducts"]),
  methods: {
    /* Resetting the store and localstorage after removing product from cart */
    ...mapMutations(["SET_CART_PRODUCTS"]),

    removeProductCart(product) {
      var products = JSON.parse(localStorage.getItem("iki-cart"));
      for (let i = 0; i < products.length; i++) {
        if (products[i].code_product === product.code_product) {
          products.splice(i, 1);
        }
      }
      this.SET_CART_PRODUCTS(products);
      localStorage.setItem("iki-cart", JSON.stringify(products));
      this.$refs.cartCalculator.analizeCart();
    },
    navigateProductDetail(product) {
      this.$router.push({
        name: "detalle-productos",
        params: { id: product.code_product }
      });
      
    },
    scroll_inicio(){
      window.scrollTo(0,0);
    }
  },
  
  created() {
    this.scroll_inicio();
  }

};
</script>

<style lang="scss">
.cart-products {
  @media(min-width:992px) {
     padding-top: 104px;
  }
}



.error-template {
  padding: 40px 15px;
  text-align: center;
}

.error-actions {
  margin-top: 15px;
  margin-bottom: 15px;
}

.error-actions .btn {
  margin-right: 10px;
}

.carrito {
    height: 60px;
    padding-bottom: 20px;
    margin-bottom: 20px;
}

.h4-carrito{
    margin-bottom: 2px;
    text-align: justify;
    color: grey;
    font-size: 21px;
}
</style>
